// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import store from './store'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.prototype.axios = axios;

// 路由跳转之前
router.beforeEach((to, from, next) => {
  let isLogin = sessionStorage.getItem('isLogin');
  // 注销
  if(to.path=='/logout') {
    // 清空
    sessionStorage.clear();
    // 跳转到登录页面
    next({path: '/login'});
  } else if(to.path=='/login') {
    // 判断是否为空，不为空跳转到首页
    if(isLogin != null) {
      next({path: '/'});
    }
  } else if(isLogin == null && to.path.search("/News") == -1 && to.path.search('/ReleaseReview') == -1) {
    next({path: '/login'});
  }

  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js